import { PushNotification } from '../models'
import type { ColumnsType } from 'antd/lib/table'
import {
  CustomText,
  CustomHeaderText,
  FormLabels, PushNotificationActionsColumn
} from 'src/components'
import moment from 'moment'

const PushNotificationsColumns: ColumnsType<PushNotification> = [
  {
    title: () => <CustomHeaderText text='Owner'/>,
    responsive: ['sm'],
    sorter: (a: PushNotification, b: PushNotification) => a.owner.length - b.owner.length,
    render: (_, pushNotification) => (
      <div style={{ marginBottom: '-15px' }}>
        <FormLabels
          title={pushNotification.owner}
        />
      </div>
    )
  },
  {
    title: () => <CustomHeaderText text='Title'/>,
    responsive: ['sm'],
    sorter: (a: PushNotification, b: PushNotification) => a.title.length - b.title.length,
    render: (_, pushNotification) => (
      <div className='mt-2'>
        <CustomText
          label={ pushNotification.title }
          style={ { color: 'blue' } }
        />
      </div>
    )
  },
  {
    title: () => <CustomHeaderText text='Datetime' isCentered/>,
    responsive: ['sm'],
    sorter: (a: PushNotification, b: PushNotification) =>
      moment(a.scheduledTime).diff(b.scheduledTime),
    render: (_, pushNotification) => (
      <CustomText
        label={moment(pushNotification.scheduledTime).format('DD-MM-YYYY HH:mm')}
        className='centered mt-3'
        strong
      />
    )
  },
  {
    title: () => <CustomHeaderText text={'general.Actions'} isCentered/>,
    align: 'center',
    responsive: ['sm'],
    render: (_, pushNotification) => {
      pushNotification.scheduledTime=moment(pushNotification.scheduledTime)
      return (
        <PushNotificationActionsColumn notification={pushNotification}/>
      )
    }
  },

]

export default PushNotificationsColumns
